import { html } from 'fxjs/es';
import { nanoid } from 'nanoid';
import { UtilImageS } from '../../../../Util/Image/S/Function/module/UtilImageS.js';
import { MShopAppStoreCommunityConstantS } from '../../../App/Store/Community/S/Constant/module/MShopAppStoreCommunityConstantS.js';
import { MShopUtilConstantS } from '../../../Util/S/Constant/module/MShopUtilConstantS.js';
import { MShopCoreConstantS } from '../Constant/module/MShopCoreConstantS.js';

/**
 * @param {string} klass - 이벤트 선택자로 활용
 * @returns {string}
 */
export const instagramIcon = (klass = '') => {
  const component = `${MShopCoreConstantS.core_klass.icon}-sns`;
  return html`
    <span class="${component} ${MShopCoreConstantS.core_klass.icon} ${klass}">
      <svg width="16px" height="16px" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M4.93359 0.800049H10.8C13.0824 0.800049 14.9336 2.65045 14.9336 4.93365V10.8C14.9336 13.0824 13.0824 14.9336 10.8 14.9336H4.93359C2.65039 14.9336 0.799988 13.0824 0.799988 10.8V4.93365C0.799988 2.65045 2.65039 0.800049 4.93359 0.800049ZM10.8 2.13365H4.93359C3.38719 2.13365 2.13359 3.38725 2.13359 4.93365V10.8001C2.13359 12.3465 3.38719 13.6001 4.93359 13.6001H10.8C12.3464 13.6001 13.6 12.3465 13.6 10.8001V4.93365C13.6 3.38725 12.3464 2.13365 10.8 2.13365Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M11.4664 7.84002C11.4664 5.83762 9.84322 4.21362 7.84002 4.21362C5.83762 4.21362 4.21362 5.83682 4.21362 7.84002C4.21362 9.84242 5.83682 11.4664 7.84002 11.4664C9.84242 11.4664 11.4664 9.84322 11.4664 7.84002ZM5.54644 7.84004C5.54644 6.57364 6.57364 5.54644 7.84004 5.54644C9.10644 5.54644 10.1336 6.57364 10.1336 7.84004C10.1336 9.10644 9.10644 10.1336 7.84004 10.1336C6.57364 10.1336 5.54644 9.10644 5.54644 7.84004Z"
          fill="white"
        />
        <circle cx="11.6264" cy="4.10641" r="0.8536" fill="white" />
      </svg>
    </span>
  `;
};

/**
 * @param {string} klass - 이벤트 선택자로 활용
 * @returns {string}
 */
export const youtubeIcon = (klass = '') => {
  const component = `${MShopCoreConstantS.core_klass.icon}-icon-sns`;
  return html`
    <span class="${component} ${MShopCoreConstantS.core_klass.icon} ${klass}">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14.2512 2.73442C14.9392 2.91842 15.4816 3.46082 15.6656 4.14882C16 5.39682 16 8.00002 16 8.00002C16 8.00002 16 10.6032 15.6656 11.8512C15.4816 12.5392 14.9392 13.0816 14.2512 13.2656C13.0032 13.6 8 13.6 8 13.6C8 13.6 2.9968 13.6 1.7488 13.2656C1.0608 13.0816 0.5184 12.5392 0.3344 11.8512C0 10.6032 0 8.00002 0 8.00002C0 8.00002 0 5.39682 0.3344 4.14882C0.5184 3.46082 1.0608 2.91842 1.7488 2.73442C2.9968 2.40002 8 2.40002 8 2.40002C8 2.40002 13.0032 2.40002 14.2512 2.73442ZM10.4 8L6.4 5.6V10.4L10.4 8Z"
          fill="white"
        />
      </svg>
    </span>
  `;
};

/**
 * @param {string} klass - 이벤트 선택자로 활용
 * @returns {string}
 */
export const twitterIcon = (klass = '') => {
  const component = `${MShopCoreConstantS.core_klass.icon}-icon-sns`;
  return html`
    <span class="${component} ${MShopCoreConstantS.core_klass.icon} ${klass}">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M14.92 2.0008C14.7632 2.6304 14.3728 3.1648 13.8488 3.4992C13.9008 3.5872 13.948 3.6808 13.9904 3.776C14.5344 3.672 15.0544 3.5008 15.5448 3.2712C15.1856 3.82 14.7552 4.3144 14.2664 4.7376C14.2856 4.9664 14.2952 5.1984 14.2952 5.4328C14.2952 10.0936 10.4632 13.8712 5.736 13.8712C4.06 13.8712 2.4968 13.3968 1.176 12.5752L1 12.5776C2.6744 12.5776 4.2368 12.1032 5.556 11.284C4.8184 11.2968 4.0792 11.0376 3.5016 10.4992C3.1168 10.14 2.8504 9.7008 2.704 9.2304L2.8184 9.2368C3.2824 9.2584 3.7488 9.2416 4.212 9.1872C3.3216 9.0632 2.5032 8.5424 2.0392 7.704C1.7888 7.2536 1.6712 6.7656 1.6728 6.2824C2.1296 6.4408 2.6032 6.552 3.0872 6.6128C2.2448 6.0896 1.6848 5.1648 1.6848 4.1104C1.6848 3.5712 1.8312 3.0656 2.088 2.6304C2.9632 3.6808 4.092 4.5184 5.3808 5.0544L5.3888 5.0576L5.5248 5.1136L5.612 5.1464L5.6632 5.1648L5.6464 5.1592L5.724 5.1888L5.6664 5.1664L5.8864 5.2464L5.9224 5.2584L5.9728 5.2744L5.944 5.2664L5.9904 5.2808L6.02 5.2912L6.0552 5.3024L6.0064 5.2864L6.1104 5.3192L6.1824 5.3408L6.46 5.4208C6.5624 5.4488 6.6664 5.4744 6.7704 5.4976L6.8768 5.5216L6.8488 5.5152L6.9128 5.5288L7.0352 5.5536L6.9152 5.5296L7.0408 5.5544L7.0768 5.5624L7.3776 5.6136C7.6952 5.6616 8.0176 5.6936 8.3456 5.7064C8.2816 5.4664 8.2472 5.2144 8.2472 4.9544C8.2472 3.3232 9.588 2.0008 11.2424 2.0008C11.9816 2.0008 12.6584 2.2648 13.18 2.7016C13.7568 2.5656 14.3048 2.3488 14.8112 2.064L14.92 2V2.0008Z"
          fill="white"
        />
      </svg>
    </span>
  `;
};

/**
 * @param {string} klass - 이벤트 선택자로 활용
 * @returns {string}
 */
export const blogIcon = (klass = '') => {
  const component = `${MShopCoreConstantS.core_klass.icon}-sns`;
  const id = nanoid(5);
  return html`
    <span class="${component} ${MShopCoreConstantS.core_klass.icon} ${klass}">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8.87759 6.66724C8.69999 6.66724 8.54799 6.73284 8.42159 6.86484C8.29599 6.99684 8.23199 7.15684 8.23199 7.34484C8.23199 7.53204 8.29599 7.69124 8.42239 7.82404C8.54799 7.95524 8.69999 8.02164 8.87759 8.02164C9.05839 8.02164 9.21199 7.95524 9.34159 7.82404C9.46959 7.69124 9.53359 7.53204 9.53359 7.34404C9.53359 7.15684 9.46959 6.99684 9.34159 6.86484C9.21199 6.73284 9.05839 6.66724 8.87759 6.66724ZM3.36801 6.67202C3.19041 6.67202 3.03841 6.73922 2.91201 6.87042C2.78641 7.00242 2.72321 7.16242 2.72321 7.35042C2.72321 7.53762 2.78641 7.69762 2.91201 7.82962C3.03841 7.96162 3.19041 8.02722 3.36801 8.02722C3.54881 8.02722 3.70241 7.96162 3.83201 7.82962C3.96001 7.69762 4.02401 7.53762 4.02401 7.35042C4.02401 7.16242 3.96001 7.00242 3.83201 6.87042C3.70241 6.73922 3.54881 6.67282 3.36801 6.67282V6.67202ZM12.096 6.87042C12.2224 6.73922 12.3744 6.67202 12.552 6.67202L12.5512 6.67282C12.732 6.67282 12.8872 6.73922 13.0152 6.87042C13.1432 7.00242 13.2072 7.16242 13.2072 7.35042C13.2072 7.53762 13.1432 7.69762 13.0152 7.82962C12.8864 7.96162 12.732 8.02722 12.552 8.02722C12.3744 8.02722 12.2224 7.96162 12.096 7.82962C11.9704 7.69762 11.9064 7.53762 11.9064 7.35042C11.9064 7.16242 11.9696 7.00242 12.096 6.87042Z"
          fill="white"
        />
        <mask
          id="${id}"
          style="mask-type:luminance"
          maskUnits="userSpaceOnUse"
          x="0"
          y="1"
          width="16"
          height="15"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 1.59998H15.9208V15.0336H0V1.59998Z"
            fill="white"
          />
        </mask>
        <g mask="url(#${id})">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M1.736 1.59998H14.1856C15.14 1.59998 15.9216 2.40158 15.9216 3.38158V10.6072C15.9216 11.5872 15.14 12.3888 14.1856 12.3888H9.2776C9.2776 12.3888 8.2568 15.0336 7.912 15.0336C7.568 15.0336 6.624 12.3888 6.624 12.3888H1.736C0.7808 12.3888 0 11.5872 0 10.6072V3.38158C0 2.40158 0.7808 1.59998 1.736 1.59998ZM5.6808 8.6384H6.6336V6.0816C6.5568 4.4208 5.2208 4.3376 5.2208 4.3376V5.3736C5.2208 5.3736 5.6808 5.452 5.6808 6.0496V8.6384ZM14.1224 8.26079C14.1224 8.99519 13.9864 9.44319 13.6672 9.75439C13.288 10.1248 12.7472 10.1504 12.2912 10.084V9.32399C12.6712 9.36399 13.1944 9.10639 13.1936 8.60079V8.40639H13.1824C12.9688 8.70799 12.6576 8.81839 12.244 8.81839C11.86 8.81839 11.5272 8.67279 11.3024 8.40239C11.0768 8.13039 10.964 7.76799 10.964 7.31279C10.964 6.80239 11.0896 6.39759 11.34 6.09679C11.5912 5.79679 11.9488 5.65679 12.3584 5.65679C12.7248 5.65679 12.956 5.74879 13.1824 5.95919H13.1936V5.73039H14.1224V8.26079ZM10.3736 7.84478C10.2936 8.03278 10.1776 8.19998 10.024 8.34718C9.87198 8.49198 9.69838 8.60318 9.50158 8.68078C9.30478 8.75838 9.09758 8.79758 8.87838 8.79758C8.66398 8.79758 8.45918 8.75838 8.26558 8.68078C8.07038 8.60398 7.89678 8.49198 7.74238 8.34718C7.58478 8.19438 7.46558 8.02558 7.38478 7.83918C7.30398 7.65438 7.26318 7.45678 7.26318 7.24958C7.26318 7.04158 7.30318 6.84478 7.38478 6.65918C7.46558 6.47438 7.58478 6.30478 7.74238 6.15198C7.89678 6.00638 8.07038 5.89518 8.26558 5.81758C8.45918 5.73998 8.66398 5.70078 8.87838 5.70078C9.09758 5.70078 9.30478 5.73998 9.50238 5.81758C9.69838 5.89518 9.87198 6.00638 10.024 6.15198C10.1776 6.29838 10.2936 6.46638 10.3736 6.65358C10.4536 6.84078 10.4936 7.03918 10.4936 7.24958C10.4936 7.45918 10.4536 7.65758 10.3736 7.84558V7.84478ZM4.62799 8.27042C4.38159 8.55602 4.00319 8.67602 3.59039 8.67602C3.21839 8.67602 2.94639 8.56162 2.74559 8.40402H2.73359V8.60722H1.79839V4.42402H2.73359V6.02402H2.74559C2.99839 5.80162 3.33359 5.72722 3.72959 5.71362C4.06879 5.70162 4.42079 5.91922 4.63199 6.16962C4.84239 6.42002 4.99679 6.81202 4.99679 7.24562C4.99679 7.71602 4.87439 7.98722 4.62799 8.27202V8.27042Z"
            fill="white"
          />
        </g>
      </svg>
    </span>
  `;
};

/**
 * @param {string} klass - 이벤트 선택자로 활용
 * @returns {string}
 */
export const facebookIcon = (klass = '') => {
  const component = `${MShopCoreConstantS.core_klass.icon}-sns`;
  return html`
    <span class="${component} ${MShopCoreConstantS.core_klass.icon} ${klass}">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="Icon-Twitter">
          <path
            id="path1009"
            d="M1.5317 2L6.55085 8.69225L1.5 14.1333H2.63674L7.05875 9.36959L10.6316 14.1333H14.5L9.19845 7.06466L13.8997 2H12.763L8.69054 6.38732L5.40008 2H1.5317ZM3.20336 2.83498H4.98051L12.8281 13.2982H11.0509L3.20336 2.83498Z"
            fill="white"
          />
        </g>
      </svg>
    </span>
  `;
};

/**
 * @param {string} klass - 이벤트 선택자로 활용
 * @returns {string}
 */
export const emptyCheckBoxIcon = (klass) => {
  return html`
    <svg
      class="${klass}"
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      fill="none"
      viewBox="0 0 18 18"
    >
      <rect width="17" height="17" x=".5" y=".5" fill="#fff" rx="3.5" />
      <rect width="17" height="17" x=".5" y=".5" stroke="#DDD" rx="3.5" />
    </svg>
  `;
};

/**
 * @param {string} klass - 이벤트 선택자로 활용
 * @param {string} color - 배경색 지정
 * @returns {string}
 */
export const fullCheckBoxIcon = (klass, color = '#B4E114') => {
  return html`
    <svg
      class="${klass}"
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      fill="none"
      viewBox="0 0 18 18"
    >
      <rect width="18" height="18" fill="${color}" rx="4" />
      <path fill="#fff" d="m4.23 8.5 1.06-1.06 2.83 2.828-1.062 1.06z" />
      <path fill="#fff" d="m7.058 11.329 5.657-5.657 1.06 1.06L8.12 12.39z" />
    </svg>
  `;
};

/**
 * `dropDownIcon`은 부모 태그에 width, height 값을 넣어 감싸줘야 합니다.
 * @param {boolean} is_down true면 위쪽 방향, false면 아래쪽 방향
 * @param {string} klass - 엘리먼트 접근을 위한 klass이름
 * @param {string} color - 색상
 * @param {number=} stroke_width - 선 굵기
 * @return {string}
 */

export const dropDownIcon = ({
  is_down = false,
  klass = '',
  color = MShopCoreConstantS.colors.gray_600,
  stroke_width = 1,
} = {}) => {
  const component = `${MShopCoreConstantS.core_klass.icon}-dropdown`;
  return html`
    <span class="${component} ${MShopCoreConstantS.core_klass.icon} ${klass}">
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="view-when-true"
        data-view_state="${!!is_down}"
      >
        <path
          d="M13 5.5L8 10.5L3 5.5"
          stroke="${color}"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="${stroke_width}"
        />
      </svg>

      <svg
        width="100%"
        height="100%"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="view-when-false"
        data-view_state="${!is_down}"
      >
        <path
          d="M3 10.5L8 5.5L13 10.5"
          stroke="${color}"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="${stroke_width}"
        />
      </svg>
    </span>
  `;
};

/**
 * `searchIcon`은 부모 태그에 width, height 값을 넣어 감싸줘야 합니다.
 * @param {string} klass - 엘리먼트 접근을 위한 klass이름
 * @param {{selected: boolean}?} [param = { selected: false }]
 */
export const searchIcon = ({ klass, selected = false } = {}) => {
  const component = `${MShopCoreConstantS.core_klass.icon}-search`;
  const stroke_color = selected ? '#1F5EFF' : '#4E4E4E';
  const stroke_width = selected ? '2' : '1.3';
  return html`
    <span class="${component} ${MShopCoreConstantS.core_klass.icon} ${klass}">
      <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="11" cy="11" r="7.35" stroke="${stroke_color}" stroke-width="${stroke_width}" />
        <rect
          x="16.8999"
          y="17.8199"
          width="${stroke_width}"
          height="4.5"
          rx="0.65"
          transform="rotate(-45 16.8999 17.8199)"
          fill="${stroke_color}"
        />
      </svg>
    </span>
  `;
};

/**
 * `alarmIcon`은 부모 태그에 width, height 값을 넣어 감싸줘야 합니다.
 * @param {number} count - 표시할 숫자
 * @return {string}
 */
export const alarmIcon = (count = 0) => {
  const component = `${MShopCoreConstantS.core_klass.icon}-alarm`;
  const id = nanoid(5);
  return html`
    <span class="${component}">
      <span class="${MShopCoreConstantS.core_klass.icon}__badge" data-badge_count="${count}">${count}</span>
      <svg width="100%" height="100%" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask id="${id}" fill="white">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M14 3C9.85786 3 6.5 6.35786 6.5 10.5V15.5C5.11929 15.5 4 16.6193 4 18C4 19.3807 5.11929 20.5 6.5 20.5H21.5C22.8807 20.5 24 19.3807 24 18C24 16.6193 22.8807 15.5 21.5 15.5V10.5C21.5 6.35786 18.1421 3 14 3Z"
          />
        </mask>
        <path
          d="M6.5 15.5V16.8H7.8V15.5H6.5ZM21.5 15.5H20.2V16.8H21.5V15.5ZM7.8 10.5C7.8 7.07583 10.5758 4.3 14 4.3V1.7C9.13989 1.7 5.2 5.63989 5.2 10.5H7.8ZM7.8 15.5V10.5H5.2V15.5H7.8ZM6.5 14.2C4.40132 14.2 2.7 15.9013 2.7 18H5.3C5.3 17.3373 5.83726 16.8 6.5 16.8V14.2ZM2.7 18C2.7 20.0987 4.40132 21.8 6.5 21.8V19.2C5.83726 19.2 5.3 18.6627 5.3 18H2.7ZM6.5 21.8H21.5V19.2H6.5V21.8ZM21.5 21.8C23.5987 21.8 25.3 20.0987 25.3 18H22.7C22.7 18.6627 22.1627 19.2 21.5 19.2V21.8ZM25.3 18C25.3 15.9013 23.5987 14.2 21.5 14.2V16.8C22.1627 16.8 22.7 17.3373 22.7 18H25.3ZM20.2 10.5V15.5H22.8V10.5H20.2ZM14 4.3C17.4242 4.3 20.2 7.07583 20.2 10.5H22.8C22.8 5.63989 18.8601 1.7 14 1.7V4.3Z"
          fill="#111111"
          mask="url(#${id})"
        />
        <path
          d="M16 22.3999C16 23.5045 15.1046 24.3999 14 24.3999C12.8954 24.3999 12 23.5045 12 22.3999"
          stroke="#111111"
          stroke-width="1.3"
          stroke-linecap="round"
        />
      </svg>
    </span>
  `;
};

/**
 * `shoppingBagIcon`은 부모 태그에 width, height 값을 넣어 감싸줘야 합니다.
 * @param {number} count
 * @param {string} count_bg_color
 * @param {string} [count_color]
 * @return {string}
 */
export const shoppingBagIcon = (count = 0, count_bg_color, count_color = 'white', stroke_color) => {
  const component = `${MShopCoreConstantS.core_klass.icon}-shopping-bag`;

  const custom_count_bg_style = count_bg_color ? `background-color: ${count_bg_color};` : '';
  const custom_count_style = count_color ? `color: ${count_color};` : '';
  const custom_stroke_color = stroke_color || '#111111';

  return html`
    <span class="${component}">
      <span
        class="${MShopCoreConstantS.core_klass.icon}__badge ${MShopUtilConstantS.CAMPTON_KLASS}"
        data-badge_count="${count}"
        style="${custom_count_bg_style}${custom_count_style}"
      >
        <span class="${MShopCoreConstantS.core_klass.icon}__badge__count">${count}</span>
      </span>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 28 28" fill="none">
        <path
          d="M18 10.6504V6.65039C18 4.44125 16.2091 2.65039 14 2.65039V2.65039C11.7909 2.65039 10 4.44125 10 6.65039V10.6504"
          stroke="${custom_stroke_color}"
          stroke-width="1.3"
          stroke-linecap="round"
        />
        <path
          d="M4.88926 9.18334C4.95145 8.12621 5.82686 7.30078 6.88581 7.30078H21.1142C22.1731 7.30078 23.0486 8.12621 23.1107 9.18334L23.8754 22.1833C23.943 23.3321 23.0296 24.3008 21.8789 24.3008H6.12111C4.97036 24.3008 4.05698 23.3321 4.12456 22.1833L4.88926 9.18334Z"
          stroke="${custom_stroke_color}"
          stroke-width="1.3"
          stroke-linejoin="round"
        />
      </svg>
    </span>
  `;
};

/**
 * `myPageIcon`은 부모 태그에 width, height 값을 넣어 감싸줘야 합니다.
 * @param {boolean} selected - 선택된 상태인 경우 true
 * @param {string} color
 * @return {string}
 */
export const mypageIcon = ({ selected = false, color } = {}) => {
  const component = `${MShopCoreConstantS.core_klass.icon}-mypage`;
  const icon_color =
    color || selected ? MShopCoreConstantS.colors.ms_blue : MShopCoreConstantS.colors.gray_700;

  return html`
    <svg
      class="${component}"
      width="100%"
      height="100%"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 28 28"
      fill="none"
    >
      <circle
        cx="14"
        cy="8"
        r="5.35"
        stroke="${icon_color}"
        fill="${selected ? icon_color : 'none'}"
        stroke-width="1.3"
      />
      <path
        d="M24 24.5L23.1362 21.0448C22.4684 18.3738 20.0685 16.5 17.3153 16.5H14H10.6847C7.93145 16.5 5.53155 18.3738 4.8638 21.0448L4 24.5"
        fill="${selected ? icon_color : 'none'}"
        stroke="${icon_color}"
        stroke-width="1.3"
        stroke-linecap="round"
      />
    </svg>
  `;
};

/**
 * `myPageIcon`은 부모 태그에 width, height 값을 넣어 감싸줘야 합니다.
 * @param {string} [klass]
 * @param {string} color - 선택된 상태인 경우 true
 * @return {string}
 */
export const menuIcon = ({ klass = '', color = MShopCoreConstantS.colors.gray_800 } = {}) => {
  const component = `${MShopCoreConstantS.core_klass.icon}-menu`;

  return html`<svg
    class="${component} ${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 28 28"
    fill="none"
  >
    <path d="M4 6L24 6" stroke="${color}" stroke-width="1.3" stroke-linecap="round" />
    <path d="M4 14L24 14" stroke="${color}" stroke-width="1.3" stroke-linecap="round" />
    <path d="M4 22L24 22" stroke="${color}" stroke-width="1.3" stroke-linecap="round" />
  </svg>`;
};

/**
 * `shoppingBagIcon`은 부모 태그에 width, height 값을 넣어 감싸줘야 합니다.
 * @param {string} color
 * @return {string}
 */
export const editPenIcon = (color = '#fff') => {
  const component = `${MShopCoreConstantS.core_klass.icon}-edit-pen`;
  return html`
    <span class="${component}">
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="none" viewBox="0 0 15 16">
        <path
          stroke="${color}"
          stroke-linecap="round"
          stroke-linejoin="round"
          d="m7.009 12.372 6.428-7.66a1 1 0 0 0-.123-1.41l-1.916-1.606a1 1 0 0 0-1.408.123L3.564 9.477"
        />
        <path fill="${color}" d="m9.293 2.648 3.447 2.893-.643.766L8.65 3.414z" />
        <path
          stroke="${color}"
          stroke-linecap="round"
          stroke-linejoin="round"
          d="m2.276 11.01.117 3.361 3.33-.469"
        />
      </svg>
    </span>
  `;
};

/**
 * `closeIcon`은 부모 태그에 width, height 값을 넣어 감싸줘야 합니다.
 * @param {object} [param = {}]
 * @param {string} [param.color]
 * @param {string} [param.klass = '']
 */
export const closeIcon = ({ klass, color } = { klass: '' }) => {
  const component = `${MShopCoreConstantS.core_klass.icon}-close`;

  return html`
    <svg
      class="${klass} ${component}"
      width="100%"
      height="100%"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.81772 9.18198L9.18168 2.81802M9.18168 9.18198L2.81772 2.81802"
        stroke="${color || '#A2A2A2'}"
        stroke-linecap="round"
      />
    </svg>
  `;
};

export const arrowIcon = ({ klass, color } = { klass: '' }) => {
  const component = `${MShopCoreConstantS.core_klass.icon}-arrow`;

  return html` <svg
    class="${component} ${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M16.5 21L7.5 12L16.5 3"
      stroke="${color || '#111111'}"
      stroke-width="1.3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>`;
};

/**
 * `userProfile`은 부모 태그에 width, height 값을 넣어 감싸줘야 합니다.
 * @param {string} user_profile_url
 * @return {string}
 */
export const userProfile = (user_profile_url) => {
  const resize_img = UtilImageS.getResizedUrl({
    url: user_profile_url || MShopAppStoreCommunityConstantS.EMPTY_USER_IMG,
    quality: 80,
    width: 140,
    format: 'webp',
  });

  return html`<div
    class="mshop-core-icon-user-profile"
    style="width: 100%; height: 100%; border-radius: 50%; overflow: hidden;"
  >
    <img style="width: 100%; height: 100%; object-fit: cover;" src="${resize_img}" alt="user profile image" />
  </div>`;
};

/**
 * `heartIcon`은 부모 태그에 width, height 값을 넣어 감싸줘야 합니다.
 * @param {object} [param = {}]
 * @param {boolean} [param.is_on = false] - 빨간색 fill 여부
 * @param {'solid' | 'outline'} [param.type = 'outline'] - off 상태에서 가운데 채움 여부
 * @param {string} [param.klass = '']
 */
export const heartIcon = (param) => {
  const is_on = param.is_on || false;
  const type = param.type || 'outline';
  const id = nanoid(5);

  const component = `${MShopCoreConstantS.core_klass.icon}-heart`;

  const offHeart =
    type === 'outline'
      ? `<svg
        width="100%"
        height="100%"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="view-when-false"
        data-view_state="${!is_on}"
      >
        <mask
          id="${id}"
          style="mask-type:alpha"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="20"
        >
          <rect width="20" height="20" fill="#D9D9D9" />
        </mask>
        <g mask="url(#${id})">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10 6.36005C9.32141 5.29 8.14459 4 6.80718 4C4.70388 4 3 5.64091 3 7.88118C3 9.63523 3.89682 10.6293 4.43376 11.2545C4.97153 11.8798 7.34412 13.9759 10 16.0909C12.6559 13.9759 15.0285 11.8798 15.5662 11.2545C16.1032 10.6293 17 9.63523 17 7.88118C17 5.64091 15.2961 4 13.1928 4C11.8554 4 10.6786 5.29 10 6.36005Z"
            stroke="#828282"
            stroke-linejoin="round"
          />
        </g>
      </svg>`
      : html`<svg
          xmlns="http://www.w3.org/2000/svg"
          width="100%"
          height="100%"
          viewBox="0 0 24 24"
          fill="none"
          class="view-when-false"
          data-view_state="${!is_on}"
        >
          <path
            d="M12 5.78186C11.5552 5.16955 11.012 4.5457 10.3929 4.02858C9.56516 3.33715 8.55675 2.7998 7.43882 2.7998C4.15703 2.7998 1.5 5.36876 1.5 8.84435C1.5 11.4701 2.81852 13.0015 3.60071 13.9099C3.62393 13.9369 3.64668 13.9633 3.6689 13.9892L3.66915 13.9895C4.0808 14.4681 5.14868 15.4636 6.56054 16.6965C7.98404 17.9396 9.78573 19.4483 11.6885 20.9637C11.8708 21.1088 12.1292 21.1088 12.3115 20.9637C14.2143 19.4483 16.016 17.9396 17.4395 16.6965C18.8513 15.4636 19.9192 14.4681 20.3308 13.9895L20.3311 13.9892C20.3533 13.9633 20.3761 13.9369 20.3993 13.9099C21.1815 13.0015 22.5 11.4701 22.5 8.84435C22.5 5.36876 19.843 2.7998 16.5612 2.7998C15.4432 2.7998 14.4348 3.33715 13.6071 4.02858C12.988 4.5457 12.4448 5.16955 12 5.78186Z"
            fill="#111111"
            fill-opacity="0.1"
            stroke="white"
            stroke-linejoin="round"
          />
        </svg>`;

  return html`
    <span class="${component} ${param.klass}">
      ${offHeart}

      <svg
        width="100%"
        height="100%"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="view-when-true"
        data-view_state="${is_on}"
      >
        <mask
          id="${id}"
          style="mask-type:alpha"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="20"
        >
          <rect width="20" height="20" fill="#D9D9D9" />
        </mask>
        <g mask="url(#${id})">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10 6.36005C9.32141 5.29 8.14459 4 6.80718 4C4.70388 4 3 5.64091 3 7.88118C3 9.63523 3.89682 10.6293 4.43376 11.2545C4.97153 11.8798 7.34412 13.9759 10 16.0909C12.6559 13.9759 15.0285 11.8798 15.5662 11.2545C16.1032 10.6293 17 9.63523 17 7.88118C17 5.64091 15.2961 4 13.1928 4C11.8554 4 10.6786 5.29 10 6.36005Z"
            fill="${MShopCoreConstantS.colors.red_800}"
            stroke="${MShopCoreConstantS.colors.red_800}"
            stroke-width="1.3"
            stroke-linejoin="round"
          />
        </g>
      </svg>
    </span>
  `;
};

/**
 * `heartIcon`은 부모 태그에 width, height 값을 넣어 감싸줘야 합니다.
 * @param {object} [param = {}]
 * @param {boolean} [param.active]
 * @param {string} [param.klass = '']
 * @return {string}
 */
export const heartIcon2 = ({ active, klass = '' }) => {
  return html`
    <svg class="${active ? 'active' : ''}" viewBox="0 0 16 16" fill="none">
      <path
        d="M8 3.47295C7.70665 3.09192 7.35981 2.71134 6.96976 2.38798C6.37584 1.89559 5.63728 1.5 4.80718 1.5C2.43036 1.5 0.5 3.34982 0.5 5.852C0.5 7.73441 1.45565 8.83568 2.00618 9.47009C2.02306 9.48955 2.03957 9.50857 2.05565 9.52716L2.0559 9.52744C2.35244 9.86964 3.1086 10.5684 4.09512 11.4234C5.09334 12.2885 6.35628 13.3382 7.68996 14.3923C7.8717 14.5359 8.1283 14.5359 8.31004 14.3923C9.64372 13.3382 10.9067 12.2885 11.9049 11.4234C12.8914 10.5684 13.6476 9.86964 13.9441 9.52744L13.9443 9.52716C13.9604 9.50857 13.9769 9.48955 13.9938 9.47009C14.5443 8.83568 15.5 7.73441 15.5 5.852C15.5 3.34982 13.5696 1.5 11.1928 1.5C10.3627 1.5 9.62416 1.89559 9.03024 2.38798C8.64019 2.71134 8.29335 3.09193 8 3.47295Z"
        stroke="#4E4E4E"
        stroke-linejoin="round"
      />
    </svg>
  `;
};

/**
 * `swiperArrowIcon`은 부모 태그에 width, height 값을 넣어 감싸줘야 합니다.
 * @param {object} [param = {}]
 * @param {string} [param.direction = 'next' | 'prev']
 * @return {string}
 */
export const swiperArrowIcon = ({ direction = 'next' }) => {
  return html`
    <svg
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style="${direction === 'prev' ? 'transform: rotate(180deg);' : ''}"
    >
      <rect
        width="60"
        height="60"
        rx="30"
        transform="matrix(-1 0 0 1 60 0)"
        fill="#111111"
        fill-opacity="0.1"
      />
      <path
        d="M26 40L36 30L26 20"
        stroke="white"
        stroke-opacity="0.5"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  `;
};

/**
 * `commentIcon`은 부모 태그에 width, height 값을 넣어 감싸줘야 합니다.
 * @param {object} [param = {}]
 * @param {string} [param.klass = '']
 * @return {string}
 */
export const commentIcon = () => {
  const component = `${MShopCoreConstantS.core_klass.icon}-comment`;
  return html`<svg class="${component}" viewBox="0 0 16 16" fill="none">
    <path
      d="M0.5 8C0.5 3.85786 3.85786 0.5 8 0.5V0.5C12.1421 0.5 15.5 3.85786 15.5 8V14C15.5 14.8284 14.8284 15.5 14 15.5H8C3.85786 15.5 0.5 12.1421 0.5 8V8Z"
      stroke="#4E4E4E"
    />
    <rect x="4" y="6" width="8" height="1" rx="0.5" fill="#4E4E4E" />
    <rect x="4" y="9" width="6" height="1" rx="0.5" fill="#4E4E4E" />
  </svg> `;
};

export const chevronRight = () => {
  return html`
    <svg viewBox="0 0 12 12" fill="none">
      <path d="M4 10L8 6L4 2" stroke="#111111" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  `;
};

/**
 * `shareIconBtn`은 부모 태그에 width, height 값을 넣어 감싸줘야 합니다.
 * @param {object} [param = {}]
 * @param {string} [param.klass = '']
 * @return {string}
 */
export const shareIconBtn = ({ klass = '' } = {}) => {
  return html`
    <svg viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M21.666 5.5L7.16602 14L21.666 22.5" stroke="#CCCCCC" />
      <circle cx="7" cy="13.5" r="3" fill="white" stroke="#CCCCCC" stroke-linejoin="round" />
      <circle cx="21.334" cy="5.5" r="3" fill="white" stroke="#CCCCCC" stroke-linejoin="round" />
      <circle cx="21.334" cy="21.5" r="3" fill="white" stroke="#CCCCCC" stroke-linejoin="round" />
    </svg>
  `;
};

export const earthIcon = () => {
  return html`
    <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 12 12" fill="none">
      <circle cx="6" cy="6" r="5.625" stroke="#4E4E4E" stroke-width="0.75" />
      <path
        d="M8.375 6C8.375 7.61554 8.07411 9.05993 7.60364 10.0864C7.11817 11.1456 6.52357 11.625 6 11.625C5.47643 11.625 4.88183 11.1456 4.39636 10.0864C3.92589 9.05993 3.625 7.61554 3.625 6C3.625 4.38446 3.92589 2.94007 4.39636 1.9136C4.88183 0.854384 5.47643 0.375 6 0.375C6.52357 0.375 7.11817 0.854384 7.60364 1.9136C8.07411 2.94007 8.375 4.38446 8.375 6Z"
        stroke="#4E4E4E"
        stroke-width="0.75"
      />
      <path
        d="M11.625 6C11.625 6.60987 11.1209 7.26295 10.0749 7.78591C9.05144 8.29766 7.61126 8.625 6 8.625C4.38874 8.625 2.94856 8.29766 1.92506 7.78591C0.879142 7.26295 0.375 6.60987 0.375 6C0.375 5.39013 0.879142 4.73705 1.92506 4.21409C2.94856 3.70234 4.38874 3.375 6 3.375C7.61126 3.375 9.05144 3.70234 10.0749 4.21409C11.1209 4.73705 11.625 5.39013 11.625 6Z"
        stroke="#4E4E4E"
        stroke-width="0.75"
      />
    </svg>
  `;
};
